module.exports = __webpack_public_path__ + "static/media/blockchainDefi.d5697e4f.png";